import React from 'react';
import { PropTypes } from 'prop-types';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Layout, Menu } from 'antd';
import LogoGiowebMini from '../../../assets/img/gioweb2_logo_mini.svg';
import LogoGioweb from '../../../assets/img/gioweb2_logo_white.svg';
import {
  Box, Flex, ShowIf,
} from '../../shared/components';
import { LEFT_SIDEBAR_WIDTH, LEFT_SIDEBAR_WIDTH_AND_MARGIN } from '../../../state/actions/constants/app.constants';


const { Sider } = Layout;
const { SubMenu } = Menu;

export default class AppSidebar extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      collapsed: true,
    };
  }

  toggle = () => {
    const { collapsed } = this.state;
    this.setState({
      collapsed: !collapsed,
    });
  };

  render() {
    const { collapsed } = this.state;
    const { menu } = this.props; 
    const MenuItems = menu.filter(e => e.visible === undefined || e.visible).map((item) => {
      const {
        text, icon, key, onClick, disabled, visible, submenu
      } = item;
      return !submenu ? (
          <Menu.Item key={key} onClick={disabled ? null : onClick || null} style={disabled ? { cursor: 'not-allowed' } : {}}>
            <Flex
              className="menu-item-block"
              width="100%"
              height="100%"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              color={disabled ? 'rgba(0, 0, 0, 0.25)' : undefined}
            >
              <Box>
                {icon}
              </Box>
              <ShowIf condition={collapsed !== true}>
                <Box>
                  { text }
                </Box>
              </ShowIf>
            </Flex>
          </Menu.Item>
        ) : (
          <SubMenu title={             
            <Flex
              className="menu-item-block"
              width="100%"
              height="100%"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              color={disabled ? 'rgba(0, 0, 0, 0.25)' : undefined}
            >
              <Box>
                {icon}
              </Box>
              <ShowIf condition={collapsed !== true}>
                <Box>
                  { text }
                </Box>
              </ShowIf>
            </Flex> 
          }>
            <Menu.ItemGroup>
              { submenu.map((el)=>
                <Menu.Item key={el.key} style={{backgroundColor: 'white', marginTop: '-4px'}} onClick={el.disabled ? null : el.onClick || null}>
                  {el.text}
                </Menu.Item>
              )}
            </Menu.ItemGroup>
          </SubMenu>
        )
    });

    return (
      <Box id="sidebar" height="100%" backgroundColor="#f0f2f5" zIndex="100">
        <Sider
          style={{
            height: '100%', width: LEFT_SIDEBAR_WIDTH, backgroundColor: '#f0f2f5',
          }}
          breakpoint="lg"
          trigger={null}
          collapsible
          collapsed={collapsed}
          collapsedWidth={64}
        >
          <div className="logo">
            <NavLink to="/">
              <img className="logo-small" src={LogoGiowebMini} />
              <img className="logo-large" style={{ display: 'block', margin: 'auto auto' }} src={LogoGioweb} />
            </NavLink>
          </div>
          <Box style={{ width: '100%' }}>
            <Box id="custom-menu-trigger" onClick={this.toggle}>
              <div className="line">&nbsp;</div>
              <Box className="ball">
                <FontAwesomeIcon icon={collapsed ? faChevronRight : faChevronLeft} size="1x" />
              </Box>
            </Box>
          </Box>
          <Menu id="#antd-main-menu" mode="vertical">
            { MenuItems }
          </Menu>
        </Sider>
      </Box>
    );
  }
}

AppSidebar.propTypes = {
  menu: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    icon: PropTypes.any,
    text: PropTypes.any,
    submenu: PropTypes.any,
    onClick: PropTypes.func,
    navLink: PropTypes.string,
    disabled: PropTypes.bool,
    visible: PropTypes.bool,
  })),
};

AppSidebar.defaultProps = {
  menu: [],
};
